import { css } from "@emotion/react";

export const footer = css({
  marginTop: "1.5rem",
  // Adding big margin to the bottom to apply the active style for the last section of the right column
  // when scrolling to all the way down to the bottom of the page
  marginBottom: "15rem",
  display: "flex",
});

export const leftButton = css({
  marginRight: "auto",
});

export const rightButton = css({
  marginLeft: "auto",
});
